<svg
    viewBox="0 0 407.1 64.6"
>
    <g>
        <polygon class="pattern_st0" points="70.7,45 31.7,45 39.8,25.4 78.8,25.4 	" />
        <polygon class="pattern_st1" points="114.1,45 105.9,64.6 0,64.6 0,45 	" />
        <polygon class="pattern_st1" points="42.7,0 34.5,19.6 0,19.6 0,0 	" />
        <polygon class="pattern_st0" points="82.3,45 79.1,45 87.3,25.4 90.5,25.4 	" />
        <polygon class="pattern_st0" points="76.5,45 73.3,45 81.5,25.4 84.7,25.4 	" />
    </g>
</svg>
